/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { customFormStyles } from "./styles";
import { CfForm, CfFormProps } from "../../components/CfForm";
import { useSTR } from "react-str";
import { URL } from "../../API/urlEndpoints";
import { getData, postData } from "../../utils/fetchers";
// import { CustomButton } from "../../atoms/CustomButton";
import {
  CustomButtonColor,
  CustomButtonTypes,
} from "../../atoms/CustomButton/interface";
// import blueTick from "../../assets/blue-background-tick.png";
import { useParams } from "react-router-dom";
import {
  loadingScreenValues,
  routeURL,
  ToastMessages,
} from "../../constants/commons";
import { useHistory } from "react-router-dom";
import { toast } from "../../utils/toast";
import { ShowMessage } from "../../components/ShowMessage";
import { useIsMobile, useIsTab } from "../../hooks/useIsMobile";
import { useUserContext } from "../../hooks/cookieHooks";

interface PartnerForms {}

export const CustomForm: React.FunctionComponent<PartnerForms> = (props) => {
  const leadId = useUserContext()?.empId || "";
  const routeHistory = useHistory();
  const isMobile = useIsMobile();
  const isTablet = useIsTab();
  const { userId } = useParams() as any;
  const [cfFormObj, setCfFormObj] = React.useState<CfFormProps>({
    show: true,
    formPageResponse: {},
    formUserResponse: {},
    triggerAction: (action: any) => {},
    sendUserResponse: (response: any) => {
      setFormSubmitted(true);
      repostUserFormData(`${URL.postUserForm(leadId)}`, response);
    },
    templateView: userId ? "FULL_SCREEN_MODAL" : "FORM_ONLY",
  });

  const [formSubmitted, setFormSubmitted] = React.useState<boolean>(false);
  const [formCompleted, setFormCompleted] = React.useState<boolean>(false);
  const [showCompletedModal, setShowCompletedModal] = React.useState<boolean>(
    false
  );

  const [
    ,
    {
      result: getUserFormDataResult,
      revalidator: refetchUserFormData,
      loading: isLoading,
      error: getUserFormDataError,
    },
  ] = useSTR(getData);

  const [
    ,
    {
      result: postUserFormDataResult,
      revalidator: repostUserFormData,
      loading: isLoadingPostCall,
      error: postUserFormDataError,
    },
  ] = useSTR(postData);

  React.useEffect(() => {
    if (userId) {
      refetchUserFormData(`${URL.getQuizResponse(userId)}`);
    } else {
      refetchUserFormData(`${URL.getUserForm(leadId)}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (!isLoading && getUserFormDataResult) {
      setCfFormObj((prevState) => {
        return {
          ...prevState,
          formPageResponse: getUserFormDataResult.screenDetails,
          formUserResponse: getUserFormDataResult.userResponse,
        };
      });
      if (
        getUserFormDataResult.userResponse &&
        getUserFormDataResult.userResponse.formCompletedStatus === "COMPLETED"
      ) {
        setCfFormObj((prevState) => {
          return {
            ...prevState,
            isDisabled: true,
          };
        });
        setFormSubmitted(true);
        setFormCompleted(true);
        if (!userId) setShowCompletedModal(true);
      }
    }
  }, [isLoading, getUserFormDataResult, userId]);

  React.useEffect(() => {
    if (
      !isLoadingPostCall &&
      postUserFormDataResult &&
      postUserFormDataResult.success
    ) {
      setCfFormObj((prevState) => {
        return {
          ...prevState,
          formPageResponse: postUserFormDataResult.form.screenDetails,
          formUserResponse: postUserFormDataResult.form.userResponse,
        };
      });
      if (
        postUserFormDataResult.form.userResponse &&
        postUserFormDataResult.form.userResponse.formCompletedStatus ===
          "COMPLETED"
      ) {
        setCfFormObj((prevState) => {
          return {
            ...prevState,
            isDisabled: true,
          };
        });
        setFormCompleted(true);
        setShowCompletedModal(true);
      } else {
        toast.warn(ToastMessages.WARN_QUIZ_SUBMIT);
      }
    }
  }, [isLoadingPostCall, postUserFormDataResult]);

  const closeSubmittedModal = () => {
    routeHistory.push(routeURL.dashboard);
  };

  return (
    <div css={customFormStyles(isMobile || isTablet ? true : false)}>
      {!userId && (
        <div className="heading-text">All the question are mandatory</div>
      )}
      <ShowMessage
        visible={isLoading || isLoadingPostCall}
        loading={isLoading || isLoadingPostCall}
        heading={isLoading ? "Loading" : "Saving"}
        description={
          isLoading
            ? loadingScreenValues.LOAD_QUIZ_MESSAGE
            : loadingScreenValues.SUBMIT_LOAD_MESSAGE
        }
      />
      {!isLoading && (
        <React.Fragment>
          {!getUserFormDataError && <CfForm {...cfFormObj} />}
          {getUserFormDataError && (
            <div>
              There was error fetching the form. Please reload & try again!
            </div>
          )}
        </React.Fragment>
      )}
      {formSubmitted && (
        <React.Fragment>
          {!formCompleted && !isLoadingPostCall && (
            <React.Fragment>
              {postUserFormDataError && (
                <div>
                  There was error submitting the form. Please try again!
                </div>
              )}
            </React.Fragment>
          )}
          <ShowMessage
            visible={formCompleted && showCompletedModal ? true : false}
            loading={false}
            heading={"Form Submitted"}
            description={loadingScreenValues.TEAM_MESSAGE}
            bodyImageFileName={"blue-background-tick.png"}
            footerButtons={[
              {
                key: 1,
                text: "Done",
                color: CustomButtonColor.PRIMARY,
                type: CustomButtonTypes.BUTTON,
                onClick: (event: React.MouseEvent) => {
                  closeSubmittedModal();
                },
              },
            ]}
            onCloseIconClick={closeSubmittedModal}
          />
        </React.Fragment>
      )}
    </div>
  );
};
